import React from "react";

import Framework from "@beardeddevops/react.framework";
import { Parts, Types } from "components";
import ObjectOverride from "components/ObjectOverride";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import { Alert, Button } from "reactstrap";
import Access from "constants/Access";
import API from "@beardeddevops/react.api";


/**
 *  @property {Users_Object} state
 *  @property {object} model
 *  @property {Users_Properties} model.properties
 *  @property {Users_Is} model.is
 *  @property {Users_Has} model.has
 */
class UserObject extends ObjectOverride {
	constructor(props) {
		super(props, Types.Users._name);
		this.state.bypass_max_users = false;

		this.state.pin_1 = '';
		this.state.pin_2 = '';
		this.state.pin_3 = '';
		this.state.pin_4 = '';

		// Change the standard Delete message to be more appropriate for a Disable button.
		this.delete_message = 'Are you sure you want to disable this user?'
	}

	/**
	 * @param prevProps
	 * @param {Users_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		/** @type {Users_Object} object */
		let object = this.state;

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(object.name_first + " " + object.name_last);
		}
	}

	// noinspection JSUnusedLocalSymbols
	loadSelfAfter(data) {
		this.setState({
			pin_1: (data['pin'] || '').split('')[0] || '',
			pin_2: (data['pin'] || '').split('')[1] || '',
			pin_3: (data['pin'] || '').split('')[2] || '',
			pin_4: (data['pin'] || '').split('')[3] || ''
		});
	};

	handleProcess(event, requestOverride) {
		let result = super.handleProcess(event, requestOverride);

		// noinspection JSValidateTypes
		/** @type {Users_Object} object */
		let object = this.state;

		if (object.pkey && object.password === '' && this.state.enabled) {
			this.setState({
				'password_error': 'Please enter your password'
			});
			result = false;
		}

		// noinspection JSIncompatibleTypesComparison
		if (object.pkey && object.password_new !== '' && object.password_new !== object.password_repeat) {
			this.setState({
				'password_repeat_error': 'Passwords must match'
			});
			result = false;
		}

		if (!object.pkey && object.password !== object.password_repeat) {
			this.setState({
				'password_repeat_error': 'Passwords must match'
			});
			result = false;
		}

		return result;
	}

	async handleSubmit(event, suppressToast = false) {
		let reEnabled = false;
		let users = this.props.rootState.userCount.split(' ');
		if (users.length === 4 && parseInt(users[0]) >= parseInt(users[3]) && !this.state.bypass_max_users) {
			this.setState({bypass_max_users: true})
			API.Toast.warn("Max user allotment exceeded. Submit again to bypass this warning.", {
				position: API.Toast.POSITION.TOP_CENTER,
				autoClose: 4000
			});
		} else {
			if (this.state.pkey && !this.state.enabled && this.handleProcess(event)) {
				this.update = 'POST_ENABLE';
				//faux setting the password on re-enable since it is "required"
				this.state.password = 'AAAAAAAA';
				reEnabled = true;
			}

			this.state.pin = this.state.pin_1 + this.state.pin_2 + this.state.pin_3 + this.state.pin_4;
			await super.handleSubmit(event, suppressToast);
			this.setState({
				password: '',
				password_new: '',
				password_repeat: ''
			})
			if (reEnabled) {
				this.update = 'POST';
				this.props.reloadPage();
			}
		}
	}

	shouldBeDisabled(_id, my_id, theirAccess, myAccess) {
		//If Object Exist
		if (_id) {
			if (my_id !== _id && myAccess < theirAccess) {
				return false;
			}

			return true;
		}

		return false
	}

	setPin = (event) => {
		let next = event.target.getAttribute('data-next');
		let newValue = event.target.value;
		if (
			newValue === '' ||
			(parseInt(newValue) >= 0 && newValue.length === 1)
		) {
			this.setState({[event.target.name]: newValue}, () => {
				if (newValue !== '' && next) {
					document.getElementsByName(next)[0].focus();
				}
			});
		}
	};

	handleKeyPress = (event) => {
		let previous = event.target.getAttribute('data-previous');
		if (event.key === 'Backspace' && previous) {
			document.getElementsByName(previous)[0].focus();
		}
	}


	form = () => {
		/** @type {Users_Properties} properties */
		let properties = this.model.properties;
		/** @type {Users_Object} object */
		let object = this.state;
		let { rootState } = this.props;
		let { userAccess } = rootState;
		let { loading } = this.state;
		let shouldBeDisabled = this.shouldBeDisabled(object._id, rootState.user, object.user_accesses.level, userAccess);

		return (
			<div>
				{this.state.pkey && !object.enabled && <Alert color="danger">
					<p style={{fontSize: '18px', marginBottom: '0px', textAlign: 'center'}}>
						<b>User is disabled.</b> You may re-enable this user using the button at the bottom of the page.<br/>
						<i>Disabled users do NOT count towards subscription limits.</i>
					</p>
				</Alert>}

				<div className={"row"}>
					{/*#region Col 1*/}
					<div className={"col-md"}>

						<fieldset disabled={this.state.pkey && !object.enabled}>

							{/*#region Login Section*/}
							<h4 className="section-title">Login</h4>
							<div className="form-group">
								<Framework.Elements.EmailAddress
									property={properties.email}
									value={object.email}
									error={object.email_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							{/*#endregion*/}

							{/*#region Update Password Section*/}
							{this.state.pkey && <h4 className="section-title">Update Password (or leave blank)</h4>}
							{!this.state.pkey && <h4 className="section-title">New Password</h4>}

							{!this.state.pkey && <div className="form-group">
								<Framework.Elements.TextField
									type="password"
									property={properties.password}
									value={object.password}
									error={object.password_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>}
							{this.state.pkey && <div className="form-group">
								<Framework.Elements.TextField
									type="password"
									property={properties.password_new}
									value={object.password_new}
									error={object.password_new_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>}
							<div className="form-group">
								<Framework.Elements.TextField
									type="password"
									label={'Retype Password'}
									property={properties.password_repeat}
									value={object.password_repeat}
									error={object.password_repeat_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							{/*#endregion*/}

							{/*#region User Section*/}
							<h4 className="section-title">User</h4>
							<div className={'row'}>
								<div className={'col-md'}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.name_first}
											value={object.name_first}
											error={object.name_first_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={'col-md'}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.name_last}
											value={object.name_last}
											error={object.name_last_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							{userAccess <= Access.Manager && <div className="form-group">
								<Framework.Elements.TextField
									property={properties.title}
									value={object.title}
									error={object.title_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>}

							{userAccess <= Access.Manager && <Parts.SelectLocation
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								locations={this.props.locations}
								states={this.props.states}
								filter={this.filterLocationOptions}
								nullable={true}
							/>}

							{/* If Manger/Owner OR Self */}
							{/* Disable = IF ! Manager/Owner || Manager && Self || Record is Manager */}
							{(userAccess <= Access.Manager || rootState.user === object._id) && <div className="form-group">
								<Framework.Elements.Select
									disabled={shouldBeDisabled}
									shouldLoad={this.state.loaded}
									update={this.handleSelectPropertyUpdate}
									property={properties.access}
									value={object.access}
									object={object.user_accesses}
									error={object.access_error}
									nullable={false}
								/>
							</div>}

							{/*#endregion*/}


							<h4 className="section-title">Kiosk & IOI Pen Code</h4>
							<div className="form-group">
								<div className={'row'}>
									<div className={'col-md'}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											name="pin_1"
											value={this.state.pin_1}
											onChange={this.setPin}
											onKeyUp={this.handleKeyPress}
											type={'number'}
											inputProps={{
												'data-next': 'pin_2',
												maxLength: 1,
												style: {
													lineHeight: '40px',
													fontSize: '40px',
													textAlign: 'center',
												}
											}}
										/>
									</div>
									<div className={'col-md'}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											name="pin_2"
											value={this.state.pin_2}
											onChange={this.setPin}
											onKeyUp={this.handleKeyPress}
											type={'number'}
											inputProps={{
												'data-previous': 'pin_1',
												'data-next': 'pin_3',
												maxLength: 1,
												style: {
													lineHeight: '40px',
													fontSize: '40px',
													textAlign: 'center',
												}
											}}
										/>
									</div>
									<div className={'col-md'}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											name="pin_3"
											value={this.state.pin_3}
											onChange={this.setPin}
											onKeyUp={this.handleKeyPress}
											type={'number'}
											inputProps={{
												'data-previous': 'pin_2',
												'data-next': 'pin_4',
												maxLength: 1,
												style: {
													lineHeight: '40px',
													fontSize: '40px',
													textAlign: 'center',
												}
											}}
										/>
									</div>
									<div className={'col-md'}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											name="pin_4"
											value={this.state.pin_4}
											onChange={this.setPin}
											onKeyUp={this.handleKeyPress}
											type={'number'}
											inputProps={{
												'data-previous': 'pin_3',
												maxLength: 1,
												style: {
													lineHeight: '40px',
													fontSize: '40px',
													textAlign: 'center',
												}
											}}
										/>
									</div>
								</div>
							</div>

							{/*#region LEEP Credentials Section*/}
							<h4 className="section-title">LEEP Credentials</h4>
							<p>
								Using the <a
								href={'https://chrome.google.com/webstore/detail/ffl-boss-nics-autofill/gkcaldngjihkfdllegnaniclnpdfcaid'}><b>FFL Boss
								eNICS Autofill plugin</b></a> you can be
								automatically logged into the LEEP portal and have
								the customers background check information auto populated.
							</p>
							<div className={'row'}>
								<div className={'col-md'}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.leep_username}
											value={object.leep_username}
											error={object.leep_username_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={'col-md'}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.leep_password}
											value={object.leep_password}
											error={object.leep_password_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							{/*#endregion*/}

						</fieldset>

					</div>
					{/*#endregion*/}
					{/*#region Col 2*/}
					<div className={"col-md"}>

						<div>
							<h4 className="section-title">Management</h4>
							<p>Please do not reuse user accounts. Disabling user accounts after employees depart and creating a new user for incoming
								employees preserves employee logs for future review.</p>
						</div>

						<h4 className="section-title">Permissions</h4>
						<p><b>Employee</b> users are able to start and complete One Page 4473s and enable Kiosk Mode.</p>
						<p><b>Supervisor</b> users have all the Employee permissions plus the ability to create acquisitions and short
							dispositions but NOT edit.</p>
						<p><b>Manager</b> users have full access to create and edit with the exception of Account & Billing information and cannot
							manage FFLs/Locations.</p>
						<p><b>Account Owners</b> (the primary login) have access to update Account & Billing information and manage
							FFLs/Locations.</p>

						{this.state.pkey && <div>
							<h4 className="section-title">Current Password</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Your Current Password"}
									value={object.password}
									error={object.password_error}
									property={properties.password}
									update={this.handleTextFieldPropertyUpdate}
									type={'password'}
								/>
							</div>
						</div>}

					</div>
					{/*#endregion*/}
				</div>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}

	render() {
		let hasModal = typeof this.props.hasModal !== 'undefined' ? this.props.hasModal : false;
		if (hasModal) {
			return this.form();
		}
		/** @type {Users_Object} object */
		let object = this.state;

		return (
			<Card style={{overflow: 'visible'}}>
				<CardContent style={{paddingBottom: 0}}>
					{this.form()}
					<hr style={{marginBottom: 0}}/>
				</CardContent>
				<CardActions style={{justifyContent: 'flex-end', padding: '14px'}}>
					{this.noDelete && object.enabled &&
					<Button color="danger" onClick={this.handleDelete}>Disable</Button>
					}
					{object.enabled && <Button color="primary" onClick={this.handleSubmit}>Save</Button>}
					{!object.enabled && <Button color="primary" onClick={this.handleSubmit}>Re-Enable</Button>}
				</CardActions>
			</Card>
		)
	}

}

export default Framework.Components.withRootState(UserObject);
